<template>
  <div class="wrap-bg wrap-back-manage wrap-back-user-manage">
    <v-breadcrumb :breadcrumb-list="breadcrumbList" />
    <!--角色列表模块-->
    <section class="bg-white role-wrap breadcrumb-btm-con-box">
      <h3 class="f-fs16 f-fwn bor-btm-gray pd15 f-df f-jcsb">
        <span>角色列表</span>
        <span class="color-blue bor-blue f-csp add-btn f-fs2" @click="addBtn()">
          <i class="el-icon-circle-plus-outline mg-right5"></i>
          <em class="f-fwn">新增</em>
        </span>
      </h3>
      <v-table-list
        :is-loading="isLoading[0]"
        :table-head="roleTableHead"
        :table-btn="roleTableBtn"
        :page-list="pageList"
        :current-page="pageObj.page"
        :page-size="pageObj.pageSize"
        :total-size="pageObj.totalSize"
        :is-show-selection="false"
        :is-table-operation-btn="true"
        :is-show-click-row-class="true"
        :active-row="activeRoleRow"
        tableMinHei="300px"
        class="pd-row15 mg-top15"
        @rowOperatBtn="rowOperatBtn"
        @sizeChange="sizeChange"
        @currentChange="currentChange"
        @rowClick="roleChange" />
    </section>
    <div class="f-df mg-top15 auth-main-con">
      <!--菜单权限列表模块-->
      <section class="bg-white role-wrap mg-right15">
        <h3 class="f-fs16 f-fwn bor-btm-gray pd15 f-df f-jcsb">
          <span>菜单权限</span>
        </h3>
        <v-table-list
          :is-loading="isLoading[1]"
          :table-head="menuLimitTableHead"
          :page-list="menuPageList"
          :is-show-selection="false"
          :is-table-operation-btn="false"
          :is-show-pagination="false"
          tableMinHei="300px"
          class="pd-row15 mg-top15"
          @enabledSwitch="menuStatusChange" />
      </section>
      <!--数据权限列表模块-->
      <section class="bg-white role-wrap">
        <h3 class="f-fs16 f-fwn bor-btm-gray pd15 f-df f-jcsb">
          <span>数据权限</span>
        </h3>
        <v-table-list
          :is-loading="isLoading[2]"
          :table-head="dataLimitTableHead"
          :page-list="dataLimitPageList"
          :is-show-selection="false"
          :is-table-operation-btn="false"
          :is-show-pagination="false"
          tableMinHei="300px"
          class="pd-row15 mg-top15"
          @enabledSwitch="dataStatesChange" />
      </section>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/list.js'
import vBreadcrumb from '@/components/breadcrumb.vue'
import vTableList from '@/components/table-list.vue'
import pageConfig from './page.config.js'
import {
  getRoleList,
  deleteRole,
  updateRole,
  getMenuLabel,
  getDataLabel
  // getListTotal
} from '@/api/backManage/userPermission.js'
export default {
  components: {
    vBreadcrumb,
    vTableList
  },
  mixins: [mixin],
  data() {
    return {
      breadcrumbList: [
        {
          name: '后台管理'
        },
        {
          name: '用户权限',
          path: '/back/userPermission'
        }
      ],
      isLoading: [false, false, false],
      roleTableHead: [], // 表头
      roleTableBtn: [], // 表格操作按钮组
      activeRoleRow: {},
      pageList: [], // 产线分析数据
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      },
      menuLimitTableHead: [],
      menuPageList: [],
      dataLimitTableHead: [],
      dataLimitPageList: []
    }
  },
  mounted() {
    this.$bus.$on('updatePermission', data => {
      // 更新列表
      this.getList(this.pageObj.page, this.pageObj.pageSize)
    })
    // 角色列表列表
    this.roleTableHead = JSON.parse(JSON.stringify(pageConfig.roleTableHead))
    this.roleTableBtn = JSON.parse(JSON.stringify(pageConfig.roleTableBtn))
    // 菜单名称
    this.menuLimitTableHead = JSON.parse(JSON.stringify(pageConfig.menuLimitTableHead))
    // 数据权限
    this.dataLimitTableHead = JSON.parse(JSON.stringify(pageConfig.dataLimitTableHead))
    // 页面初始化
    this.init()
  },
  methods: {
    init() {
      Promise.all([
        this.getMenuList(), // 获取菜单权限表格列表
        this.getDataLabel() // 获取数据权限表格列表
      ]).then(data => {
        // 获取角色表格列表
        this.refreshList()
      })
    },
    // 获取菜单权限表格列表
    getMenuList() {
      this.$set(this.isLoading, 1, true)
      return new Promise(resolve => {
        getMenuLabel().then(res => {
          this.$set(this.isLoading, 1, false)
          this.menuPageList = (res.data || []).map((item, index) => {
            item.state = 0
            return item
          })
          resolve(res)
        })
      })
    },
    // 获取数据权限表格列表
    getDataLabel() {
      this.$set(this.isLoading, 2, true)
      return new Promise(resolve => {
        getDataLabel().then(res => {
          this.$set(this.isLoading, 2, false)
          this.dataLimitPageList = (res.data || []).map((item, index) => {
            item.state = 0
            return item
          })
          resolve(res)
        })
      })
    },
    // 获取角色表格列表
    getList(currentPage, pageSize, isInit) {
      this.$set(this.isLoading, 0, true)
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      !currentPage && (this.pageObj.totalSize = -1)
      getRoleList({
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize
      }).then(res => {
        this.$set(this.isLoading, 0, false)
        const data = res.data || {}
        this.pageList = (data.items || []).map((item, index) => {
          item.status = item.enable * 1 === 1 ? '启用' : '停用'
          item.$index = index + 1
          return item
        })
        !currentPage && (this.pageObj.totalSize = data.total || 0)
        if (this.pageList.length) this.roleChange(this.pageList[0])
      })
    },
    // 当前角色改变
    roleChange(item) {
      this.activeRoleRow = item
      // 角色处理
      this.menuPageList = this.menuPageList.map((item, index) => {
        const status = (this.activeRoleRow.menuAuth || []).find(elem => elem.code + '' === item.code + '')
        item.state = status ? 1 : 0
        return item
      })
      // 数据处理
      this.dataLimitPageList = this.dataLimitPageList.map((item, index) => {
        const status = (this.activeRoleRow.dataAuth || []).find(elem => elem.platformId + '' === item.platformId + '' && elem.brandId + '' === item.brandId + '')
        item.state = status ? 1 : 0
        return item
      })
    },
    // 获取角色表格数据总数
    getListTotal() {
      // this.pageObj.totalSize = -1
      // getListTotal().then(res => {
      //   this.pageObj.totalSize = res.data || 0
      // })
    },
    // 表格按钮
    rowOperatBtn(rowData, item) {
      if (item.id === 'edit') {
        // 编辑
        this.$router.push({
          path: '/userPermission/detail',
          query: {
            id: rowData[0].roleCode,
            pageType: 'edit'
          }
        })
      } else if (item.id === 'delete') {
        // 删除
        deleteRole({
          roleId: rowData[0].roleId
        }).then(res => {
          if (res.data && res.status * 1 === 200) {
            this.$message({
              type: 'success',
              message: '保存成功！'
            })
            this.refreshList()
          } else {
            this.$message({
              type: 'error',
              message: res.message || '保存失败！'
            })
          }
        })
      }
    },
    // 添加
    addBtn() {
      this.$router.push({
        path: '/userPermission/detail',
        query: {
          pageType: 'add'
        }
      })
    },
    // 菜单权限状态修改
    menuStatusChange(row) {
      if (row.state * 1 === 1) {
        // 新加权限
        this.activeRoleRow.menuAuth.push({
          code: row.code,
          name: row.name
        })
      } else {
        this.activeRoleRow.menuAuth = this.activeRoleRow.menuAuth.filter(item => item.code !== row.code)
      }
      // 修改用户
      this.$set(this.isLoading, 1, true)
      updateRole(this.activeRoleRow).then(res => {
        this.$set(this.isLoading, 1, false)
        this.saveHandle(res)
      })
    },
    // 数据权限状态修改
    dataStatesChange(row) {
      this.activeRoleRow.dataAuth = this.activeRoleRow.dataAuth.filter(item => item.platformId * 1 !== 15)
      if (row.state * 1 === 1) {
        // 新加权限
        this.activeRoleRow.dataAuth.push(row)
      } else {
        this.activeRoleRow.dataAuth = this.activeRoleRow.dataAuth.filter(item => item.platformId !== row.platformId && item.brandId !== row.brandId)
      }
      // 修改用户
      this.$set(this.isLoading, 2, true)
      updateRole(this.activeRoleRow).then(res => {
        this.$set(this.isLoading, 2, false)
        this.saveHandle(res)
      })
    },
    // 保存后处理
    saveHandle(res) {
      if (res.data && res.status * 1 === 200) {
        this.$message({
          type: 'success',
          message: '保存成功！'
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message || '保存失败！'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.filter-box{
  & .inp-name{
    width: 300px;
  }
}
.auth-main-con {
  & section{
    width: calc(~'(100% - 15px) / 2')
  }
}
.add-btn{
  padding: 2px 8px;
  border-radius: 3px;
}
</style>
